import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './button/button.component';
import { InputComponent } from './input/input.component';
import { LinkComponent } from './link/link.component';
import { LogoImageComponent } from './logo-image/logo-image.component';
import { IconComponent } from './icon/icon.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { InputSelectComponent } from './input-select/input-select.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LineChartComponent } from './line-chart/line-chart.component';
import { LabelComponent } from './label/label.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { MatSelectModule } from '@angular/material/select';
import { BarChartComponent } from './bar-chart/bar-chart.component';
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { PieChartComponent } from './pie-chart/pie-chart.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SwitchComponent } from './switch/switch.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { InputCheckboxComponent } from './input-checkbox/input-checkbox.component';
import { MultipleDatesComponent } from './multiple-dates/multiple-dates.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatMenuModule } from '@angular/material/menu';
import { DateRangeComponent } from './date-range/date-range.component';
import { HeatMapChartComponent } from './heat-map-chart/heat-map-chart.component';
import { LoaderComponent } from './loader/loader.component';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import { MonthRangeComponent } from './month-range/month-range.component';
import { DateComponent } from './date/date.component';
import { PartitionedBarChartComponent } from './partitioned-bar-chart/partitioned-bar-chart.component';
import { InputAutocompleteComponent } from './input-autocomplete/input-autocomplete.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { LayeredColumnChartComponent } from './layered-column-chart/layered-column-chart.component';
import { InputFileComponent } from './input-file/input-file.component';

@NgModule({
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatIconModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatNativeDateModule,
    MatButtonModule,
    MatDatepickerModule,
    FormsModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatMenuModule,
    TranslateModule,
    MatAutocompleteModule
  ],
  declarations: [
    ButtonComponent,
    InputComponent,
    LinkComponent,
    LogoImageComponent,
    InputSelectComponent,
    IconComponent,
    LineChartComponent,
    BarChartComponent,
    LabelComponent,
    ProgressBarComponent,
    PieChartComponent,
    SwitchComponent,
    MonthRangeComponent,
    InputCheckboxComponent,
    MultipleDatesComponent,
    DateRangeComponent,
    HeatMapChartComponent,
    LoaderComponent,
    LanguageSelectorComponent,
    DateComponent,
    PartitionedBarChartComponent,
    InputAutocompleteComponent,
    LayeredColumnChartComponent,
    InputFileComponent
  ],
  exports: [
    ButtonComponent,
    InputComponent,
    LinkComponent,
    LogoImageComponent,
    InputSelectComponent,
    IconComponent,
    LineChartComponent,
    BarChartComponent,
    LabelComponent,
    MonthRangeComponent,
    ProgressBarComponent,
    MatCardModule,
    MatIconModule,
    PieChartComponent,
    SwitchComponent,
    InputCheckboxComponent,
    MultipleDatesComponent,
    DateRangeComponent,
    HeatMapChartComponent,
    LoaderComponent,
    LanguageSelectorComponent,
    DateComponent,
    PartitionedBarChartComponent,
    InputAutocompleteComponent,
    LayeredColumnChartComponent,
    InputFileComponent
  ],
  providers: [],
})
export class AtomsModule {}
